export const PROVIDER_PRESETS = [
  {
    id: "openai",
    name: "OpenAI",
    base_url: "https://api.openai.com/v1",
    auth_style: "bearer",
    docs: "https://platform.openai.com/api-keys",
    key_hint: "sk-...",
    supports_list_models: true,
    default_models: [
      "gpt-5.6",
      "gpt-5.5",
      "gpt-5.4",
      "gpt-4o",
      "gpt-4o-mini",
    ],
  },
  {
    id: "gemini",
    name: "Google Gemini",
    // Google publishes an OpenAI-compatible endpoint (bearer + /chat/completions
    // + /models) on top of the Gemini API. Uses the same Gemini API key.
    // Docs: https://ai.google.dev/gemini-api/docs/openai
    base_url: "https://generativelanguage.googleapis.com/v1beta/openai",
    auth_style: "bearer",
    docs: "https://aistudio.google.com/apikey",
    key_hint: "AIza...",
    supports_list_models: true,
    default_models: [
      "gemini-2.5-pro",
      "gemini-2.5-flash",
      "gemini-2.5-flash-lite",
      "gemini-2.0-flash",
    ],
  },
  {
    id: "openrouter",
    name: "OpenRouter",
    base_url: "https://openrouter.ai/api/v1",
    auth_style: "bearer",
    docs: "https://openrouter.ai/keys",
    key_hint: "sk-or-v1-...",
    supports_list_models: true,
    default_models: [
      "openai/gpt-4o",
      "anthropic/claude-3.5-sonnet",
      "google/gemini-pro-1.5",
      "meta-llama/llama-3.3-70b-instruct",
      "deepseek/deepseek-chat",
    ],
  },
  {
    id: "nvidia",
    name: "NVIDIA NIM",
    base_url: "https://integrate.api.nvidia.com/v1",
    auth_style: "bearer",
    docs: "https://build.nvidia.com/",
    key_hint: "nvapi-...",
    supports_list_models: true,
    default_models: [
      "meta/llama-3.3-70b-instruct",
      "nvidia/llama-3.1-nemotron-70b-instruct",
      "deepseek-ai/deepseek-r1",
      "mistralai/mixtral-8x22b-instruct-v0.1",
    ],
  },
  {
    id: "groq",
    name: "Groq",
    base_url: "https://api.groq.com/openai/v1",
    auth_style: "bearer",
    docs: "https://console.groq.com/keys",
    key_hint: "gsk_...",
    supports_list_models: true,
    default_models: [
      "llama-3.3-70b-versatile",
      "llama-3.1-8b-instant",
      "mixtral-8x7b-32768",
      "gemma2-9b-it",
    ],
  },
  {
    id: "together",
    name: "Together AI",
    base_url: "https://api.together.xyz/v1",
    auth_style: "bearer",
    docs: "https://api.together.ai/settings/api-keys",
    key_hint: "tok_...",
    supports_list_models: true,
    default_models: [
      "meta-llama/Llama-3.3-70B-Instruct-Turbo",
      "Qwen/Qwen2.5-72B-Instruct-Turbo",
      "deepseek-ai/DeepSeek-V3",
    ],
  },
  {
    id: "fireworks",
    name: "Fireworks",
    base_url: "https://api.fireworks.ai/inference/v1",
    auth_style: "bearer",
    docs: "https://fireworks.ai/api-keys",
    key_hint: "fw_...",
    supports_list_models: true,
    default_models: [
      "accounts/fireworks/models/llama-v3p3-70b-instruct",
      "accounts/fireworks/models/deepseek-r1",
      "accounts/fireworks/models/qwen2p5-72b-instruct",
    ],
  },
  {
    id: "deepseek",
    name: "DeepSeek",
    base_url: "https://api.deepseek.com/v1",
    auth_style: "bearer",
    docs: "https://platform.deepseek.com/api_keys",
    key_hint: "sk-...",
    supports_list_models: true,
    default_models: ["deepseek-chat", "deepseek-reasoner"],
  },
  {
    id: "mistral",
    name: "Mistral",
    base_url: "https://api.mistral.ai/v1",
    auth_style: "bearer",
    docs: "https://console.mistral.ai/",
    key_hint: "...",
    supports_list_models: true,
    default_models: [
      "mistral-large-latest",
      "mistral-small-latest",
      "codestral-latest",
    ],
  },
  {
    id: "custom",
    name: "Personalizado",
    base_url: "",
    auth_style: "bearer",
    docs: "",
    key_hint: "",
    supports_list_models: false,
    default_models: [],
  },
];
